export default class ConsumptionData {
    constructor(fuelLowSulfur, fuelOil, time) {
        this.fuelLowSulfur = fuelLowSulfur,
            this.fuelOil = fuelOil,
            this.time = time
    }
}